import { Inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BaseFpxComponentState, BaseFpxFormHelper, BaseFpxPostSubmitInterceptor, RoutingInfo } from "@fpx/core";
import { CommonService } from "src/app/common.service";
import { ProcessShellService } from "src/app/process-shell/services/process-shell.service";
import { ProfilepicResultFormService } from "./profile-pic-result-form.service";
import { DialogService } from "src/app/fpx-core/services/dialog/dialog.service";
import { CustomerService } from "src/app/services/customer.service";
import { IPopupScreenData } from "src/app/common/models/popup-screen-data.model";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { AccountSettingsComponent } from "../account-settings/account-settings.component";
import { PopupComponent } from "../popup/popup.component";
import { UserService } from "src/app/user.service";

export class ProfilepicResultFormState implements BaseFpxComponentState {
    imageData: any;
    faceMatchCheck: boolean;
    faceMatchResultData: any;
    // documentInfo:FaceMatchData;
    documentType: any;
    isFormSubmitted: boolean;
    disableBtn: boolean = false;
}

@Injectable()
export class ProfilepicResultFormHelper extends BaseFpxFormHelper<ProfilepicResultFormState>{
    formData: FormData;
    constructor(
        private _processShellService: ProcessShellService,
        private _commonService: CommonService,
        private _dialogService: DialogService,
        public userService: UserService,
        private _dialogRef: MatDialogRef<any>,
        private _dialog: MatDialog,
        private _profilepicResultService: ProfilepicResultFormService,
        private _router: Router,
        private _customerService: CustomerService,
        @Inject(MAT_DIALOG_DATA) private data: IPopupScreenData
    ) {
        super(new ProfilepicResultFormState());
    }
    public doPreInit(): void {
        this.state.imageData = undefined;
        this.state.faceMatchCheck = undefined;
        this.state.faceMatchResultData = undefined;
        this._processShellService.setTitle("Update Profile Picture");
        this._processShellService.setFooterVisible(false);
    }
    async filetoBase64(fileData) {
        this.state.imageData = await this.getBase64(fileData);
        console.log(this.state.imageData)
    }

    getBase64(file): Promise<any> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            console.log("reader", reader);

            reader.onloadend = (result) => {
                console.log(result.target.result);
                resolve(result.target.result);
            }


            reader.onerror = error => reject(error);
        });
    }

    public doPostInit(): void {
        let fileData;
        let routingParams;
        if (this._commonService.isMobile()) {
            fileData = this.getRoutingParam('photo');
            routingParams = this.getRoutingParam('additionalDetails');
        } else {
            fileData = this.data?.data?.photo;
            routingParams = this.data?.data?.additionalDetails;
        }
        if (typeof (fileData) === "string") {
            this.state.imageData = fileData;
            console.log("Insideresponse", this.state.imageData);
        }
        else {
            // this._commonService.fileToBase64(fileData).then(
            //     (res) => {
            //         this.state.imageData = res;
            //     }
            // )
            this.filetoBase64(fileData);
            //this.setImageFormData(this.state.imageData);

            this.state.documentType = routingParams?.documentType;
        }


    }
    public doDestroy(): void {
        let formClassName = this._processShellService.formClassName?.replace('onboarding-form','');;
        formClassName = formClassName + " profile-pic-capture-form";
        this._processShellService.formClassName = formClassName;
    }
    retakePhoto() {
        //  let path = this._commonService.isDesktop()?['home']:['home', 'overview'];
        if (this._commonService.isDesktop()) {
            this._dialog.closeAll()
            this._dialogRef.afterClosed().subscribe(x => {
                this.chooseProfile()
            })
        }
        else if(this._commonService.isMobile()){
            this.chooseProfile()
        }
        // this._router.navigate(path);
    }



    chooseProfile() {
        let dialogRef;
        let data: IPopupScreenData = {
            component: 'profilepicChooser'
        }
        dialogRef = this._dialog.open(PopupComponent, {
            width: '100%',
            data: data,
            panelClass: 'picpopup-info'
        });

        dialogRef.afterClosed().subscribe((data) => {
            if (data.file == 'camera') {
                let path = ['process-shell', 'settings', 'profile-pic-capture'];
                this._router.navigate(path, {
                    queryParams: {
                        photo: data.file,
                        additionalDetails: {
                            captureBy: 'camera',
                        }
                    },
                    queryParamsHandling: 'preserve'
                });
            }
            else {
                if (this._commonService.isMobile()) {
                    let path = ['process-shell', 'settings', 'profile-pic-result'];
                    this._router.navigate(path, {
                        queryParams: {
                            photo: data.file,
                            additionalDetails: {
                                captureBy: 'browse'
                            }
                        },
                        queryParamsHandling: 'preserve'
                    });
                }
                else if (this._commonService.isDesktop()) {

                    // let path = ['process-shell', 'settings', 'profile-pic-result'];
                    //   this._router.navigate(path, {
                    //     queryParams: {
                    //       photo: data.file,
                    //       additionalDetails: {
                    //         captureBy: 'browse'
                    //       }
                    //     },
                    //     queryParamsHandling: 'preserve'
                    //   });
                    this._dialogService.open({

                        component: 'profilepic-result',
                        data: {
                            data: {
                                photo: data.file,
                                additionalDetails: {
                                    captureBy: 'browse'
                                }
                            }

                        },
                        panelClass: 'profilepic-result'
                    })
                }
            }

        });
    }
    douploadPhoto() {
        // this._commonService.showSpinner();
        this.state.isFormSubmitted = true;
        this.state.disableBtn = true;
        let payload = {
            'userId': sessionStorage.getItem('customerCode'),
            'photo': this.state.imageData,
        }

        this._profilepicResultService.uploadPhoto(payload).subscribe(
            (res) => {
                this._dialog.closeAll()
                this._customerService.setUserProfilePic(this.state.imageData);
                this.userService.setUserProfileImage(this.state.imageData)
                this.state.isFormSubmitted = false;
                let path = ['process-shell', 'settings', 'result-info'];
                if (this._commonService.isMobile()) {
                    if (res?.status == 200) {
                        this._router.navigate(path, {
                            queryParams: {
                                "message": "Profile photo uploaded successfully!!",
                                "currentStage": "SuccessEnd",
                                "backNavPath": "overview"
                            },
                            queryParamsHandling: 'preserve'
                        });
                    }
                    else if (res?.status == 500) {
                        this._router.navigate(['process-shell', 'settings', 'result-info'], {
                            queryParams: {
                                "message": "Failed to update the profile photo. Please try again later!!",
                                "currentStage": "FailureEnd",
                                "backNavPath": "overview"
                            },
                            queryParamsHandling: 'preserve'
                        });
                    }
                }
                else if (this._commonService.isDesktop()) {
                    if (res?.status == 200) {
                        this._dialogService.open({
                            component: 'profile-pic-result-page',
                            data: {
                                "title": "jhvjb",
                                "message": "Profile photo uploaded successfully!!",
                                "currentStage": "SuccessEnd",
                                "backNavPath": "overview",
                                data: {}
                            },
                            panelClass: ['result-page-dialog', 'pic-result-dialog']
                        })
                        return
                    }
                    else if (res?.status == 500) {
                        // this._router.navigate(path, {
                        //     queryParams: {
                        //         "message": "Failed to update the profile photo. Please try again later!!",
                        //         "currentStage": "FailureEnd",
                        //         "backNavPath": "overview"
                        //     },
                        //     queryParamsHandling: 'preserve'
                        // });
                        this._dialogService.open({
                            component: 'failure',
                            data: {
                                "title": "jhvjb",
                                "message": "Failed to update the profile photo. Please try again later!!",
                                "currentStage": "FailureEnd",
                                "backNavPath": "overview",
                                data: {}
                            },
                            panelClass: 'result-page-dialog'
                        })
                        return

                    }
                }


                // this._processShellService.triggerFormSubmittedCompleteStatus(true);
            },
            (err) => {
                this.state.isFormSubmitted = false;
                this.state.imageData = err;
            }
        );
    }

    public override preSubmitInterceptor(payload: any) {
        this.state.isFormSubmitted = true;
        payload.photo = this.state.imageData;
        return payload;
    }

    public postSubmitInterceptor(response: BaseFpxPostSubmitInterceptor): RoutingInfo {
        let routingInfo: RoutingInfo = new RoutingInfo();
        // WRITE CODE HERE TO HANDLE 
        this._processShellService.triggerFormSubmittedCompleteStatus(true);
        this.state.isFormSubmitted = false;
        return routingInfo;
    }

}

